const doc = [({"ko":({"adminComponentHotelChildrenSetting":({"addCategory":"파티션 추가", "editCategory":"구분 편집", "hotelChildrenSettingTitle":"아이 설정", "notesTitle":"주의 사항"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;